const HEX_COLOUR = /^#[0-9a-f]{6}$/i;
const HTTP_URL = /^https?:\/\//i;

export const DEFAULT_TENANT_BRANDING = Object.freeze({
  displayName: "",
  logoUrl: "",
  primaryColor: "#197fba",
  secondaryColor: "#f15c9d",
});

function safeColour(value, fallback) {
  const colour = String(value || "").trim();
  return HEX_COLOUR.test(colour) ? colour.toLowerCase() : fallback;
}

function safeLogoUrl(value) {
  const logoUrl = String(value || "").trim();
  return HTTP_URL.test(logoUrl) ? logoUrl : "";
}

export function normalizeTenantBranding(branding = {}, fallbackDisplayName = "") {
  return {
    displayName: String(branding?.displayName || fallbackDisplayName || "").trim(),
    logoUrl: safeLogoUrl(branding?.logoUrl),
    primaryColor: safeColour(
      branding?.primaryColor,
      DEFAULT_TENANT_BRANDING.primaryColor,
    ),
    secondaryColor: safeColour(
      branding?.secondaryColor,
      DEFAULT_TENANT_BRANDING.secondaryColor,
    ),
  };
}

export function getTenantBrandingStyle(branding, fallbackDisplayName = "") {
  const normalized = normalizeTenantBranding(branding, fallbackDisplayName);
  return {
    "--tenant-brand-primary": normalized.primaryColor,
    "--tenant-brand-secondary": normalized.secondaryColor,
    "--tenant-brand-gradient": `linear-gradient(90deg, ${normalized.primaryColor}, ${normalized.secondaryColor})`,
  };
}

